import { makeObservable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroGabineteRelator extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';

    get label() {
        return 'Gabinete do Relator';
    }

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    getValorOpcao(registro) {
        return registro && registro.processo.relator && registro.processo.relator.sigla;
    }
}
